<main
    class="agpr-contactImporter agpr-contactImporter-container"
    [agprLoading]="loading"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
>
    <section
        class="agpr-center"
        [attr.aria-label]="'Common.layout.main' | localize"
    >
        <div class="agpr-header-container">
            <div class="agpr-header">
                <span class="agpr-header-title">{{ 'Discover.contactImporter.header' | localize }}</span>
                <a
                    href="http://help.agilitypr.com/en/articles/5409425-importing-your-own-contacts-into-agility"
                    target="_blank"
                    class="agpr-header-bestPractices"
                >
                    {{'Discover.contactImporter.bestPractices' | localize}}
                </a>
            </div>
        </div>
        <div
            *ngIf="csvFiles.length === 0"
            class="agpr-hype-container"
        >
            <span class="agpr-i-line-import-contacts agpr-hype-bigIcon" aria-hidden="true"></span>
            <div class="agpr-hype-text">{{'Discover.contactImporter.hype.line1' | localize}}</div>
            <div class="agpr-hype-text">{{'Discover.contactImporter.hype.line2' | localize}}</div>
            <div class="agpr-hype-text">
                <span>{{'Discover.contactImporter.hype.line3' | localize}}</span>
                <span>
                <a
                    href="http://help.agilitypr.com/en/articles/5409425-importing-your-own-contacts-into-agility"
                    target="_blank"
                    class="agpr-hype-text"
                >
                    {{ 'Discover.contactImporter.hype.link' | localize }}</a>.
                </span>

            </div>
            <agpr-button
                label="Discover.contactImporter.hype.button"
                [style]="buttonTypes.primary"
                class="agpr-hype-startImport"
                (click)="fileInput.click()"
            >
            </agpr-button>
        </div>
        <div
            *ngIf="csvFiles.length > 0"
            class="agpr-filetabs-container"
        >
            <agpr-tabs>

                <ng-template #tabTemplate let-tab="tab">
                    <div
                        class="agpr-filetabs-tab"
                        [pTooltip]="tab.heading"
                        tooltipPosition="top"
                    >
                        {{tab.heading}}
                    </div>
                </ng-template>

                <agpr-tab
                    *ngFor="let file of csvFiles; let fileIndex = index"
                    [heading]="file.fileName"
                    [id]="'contactImport.tab' + fileIndex"
                >
                    <agpr-scroll-panel>
                        <div
                            *ngIf="file.csvColumns && file.csvFields"
                            class="agpr-fieldlist-container"
                            [id]="fileIndex"
                        >
                            <div class="agpr-fieldlist-gridContainer agpr-fieldlist-header">
                                <span class="agpr-fieldlist-headerLabels">{{ 'Discover.contactImporter.columnHeaders.fields' | localize }}</span>
                                <span class="agpr-fieldlist-headerLabels">{{ 'Discover.contactImporter.columnHeaders.columns' | localize }}</span>
                                <span class="agpr-fieldlist-headerLabels">{{ 'Discover.contactImporter.columnHeaders.preview' | localize }}</span>
                            </div>
                            <ng-container *ngFor="let row of displayRowsPerFile[fileIndex]">
                                <!-- Regular fields -->
                                <div
                                    *ngIf="row.kind === 'single'"
                                    class="agpr-fieldlist-gridContainer agpr-greyLine"
                                >
                                    <div class="agpr-fieldlist-fieldLabels">
                                        <span>{{row.field.originalField.label | localize}}</span>
                                        <span
                                            *ngIf="row.field.originalField.required"
                                            class="agpr-requiredAsterix"
                                        > *</span>
                                    </div>
                                        <agpr-dropdown
                                            [id]="id + '_' + fileIndex + '_field_' + row.field.originalField.fieldId + '_dropdown'"
                                            [options]="csvColumnDropdownOptions[fileIndex]"
                                            [(ngModel)]="selectedOptions[fileIndex][row.fieldIndex]"
                                            (ngModelChange)="onDropdownChanged($event, file, row.field)"
                                            placeholder="Discover.contactImporter.placeholders.input"
                                            [ariaLabel]="row.field.originalField.label"
                                        ></agpr-dropdown>
                                    <span
                                        *ngIf="row.field.exampleValue"
                                        class="agpr-fieldlist-fieldExamples"
                                    >
                                        {{row.field.exampleValue}}
                                    </span>
                                    <span
                                        *ngIf="!row.field.exampleValue && selectedOptions[fileIndex][row.fieldIndex]?.value?.columnIndex === null"
                                        class="agpr-fieldlist-fieldExamples-placeholder"
                                    >
                                        {{ 'Discover.contactImporter.placeholders.preview' | localize }}
                                    </span>
                                    <span
                                        *ngIf="!row.field.exampleValue && selectedOptions[fileIndex][row.fieldIndex]?.value?.columnIndex !== null"
                                        class="agpr-fieldlist-fieldExamples-placeholder"
                                    >
                                        {{ 'Discover.contactImporter.placeholders.noData' | localize }}
                                    </span>
                                </div>

                                <!-- Radio group (name fields) -->
                                <ng-container *ngIf="row.kind === 'radioGroup'">

                                    <!-- Group header row -->
                                    <div class="agpr-fieldlist-gridContainer agpr-fieldlist-radioGroupHeader agpr-greyLine">
                                        <span class="agpr-fieldlist-fieldLabels">
                                            <span>{{ row.groupLabel | localize }}</span>
                                            <span
                                                *ngIf="row.required"
                                                class="agpr-requiredAsterix"
                                            > *</span>
                                        </span>
                                    </div>

                                    <ng-container *ngFor="let option of row.options; let optionIndex = index">

                                        <!-- First Name and Last Name -->
                                        <div
                                            class="agpr-fieldlist-gridContainer agpr-fieldlist-radioOption"
                                            [class.agpr-greyLine]="option.length === 1"
                                        >
                                            <agpr-radio
                                                [id]="id + '_' + fileIndex + '_nameGroup_opt_' + optionIndex"
                                                [name]="id + '_' + fileIndex + '_nameGroup_opt_' + optionIndex"
                                                [value]="optionIndex"
                                                [(ngModel)]="row.selectedOptionIndex"
                                                (ngModelChange)="onNameRadioChanged($event, file, fileIndex, row)"
                                                [label]="option[0].field.originalField.label"
                                                [hiddenLabel]="option[0].field.originalField.label"
                                            ></agpr-radio>
                                            <agpr-dropdown
                                                [id]="id + '_' + fileIndex + '_field_' + option[0].field.originalField.fieldId + '_dropdown'"
                                                [options]="csvColumnDropdownOptions[fileIndex]"
                                                [(ngModel)]="selectedOptions[fileIndex][option[0].fieldIndex]"
                                                (ngModelChange)="onDropdownChanged($event, file, option[0].field)"
                                                placeholder="Discover.contactImporter.placeholders.input"
                                                [ariaLabel]="option[0].field.originalField.label"
                                                [disabled]="row.selectedOptionIndex !== optionIndex"
                                                [class.agpr-fieldlist-radioOption--disable-hover-effect]="row.selectedOptionIndex !== optionIndex"
                                            ></agpr-dropdown>
                                            <span
                                                *ngIf="option[0].field.exampleValue"
                                                class="agpr-fieldlist-fieldExamples"
                                            >
                                                {{option[0].field.exampleValue}}
                                            </span>
                                            <span
                                                *ngIf="!option[0].field.exampleValue && selectedOptions[fileIndex][option[0].fieldIndex]?.value?.columnIndex == null"
                                                class="agpr-fieldlist-fieldExamples-placeholder"
                                            >
                                                {{ 'Discover.contactImporter.placeholders.preview' | localize }}
                                            </span>
                                            <span
                                                *ngIf="!option[0].field.exampleValue && selectedOptions[fileIndex][option[0].fieldIndex]?.value?.columnIndex != null"
                                                class="agpr-fieldlist-fieldExamples-placeholder"
                                            >
                                                {{ 'Discover.contactImporter.placeholders.noData' | localize }}
                                            </span>
                                        </div>

                                        <!-- Full Name fields -->
                                        <ng-container *ngFor="let fieldEntry of option; let subIndex = index">
                                            <div
                                                *ngIf="subIndex > 0"
                                                class="agpr-fieldlist-gridContainer agpr-greyLine agpr-fieldlist-radioSubField"
                                            >
                                                <span
                                                    class="agpr-fieldlist-fieldLabels agpr-fieldlist-fieldLabels--indented">
                                                        {{ fieldEntry.field.originalField.label | localize }}
                                                </span>
                                                <agpr-dropdown
                                                    [id]="id + '_' + fileIndex + '_field_' + fieldEntry.field.originalField.fieldId + '_dropdown'"
                                                    [options]="csvColumnDropdownOptions[fileIndex]"
                                                    [(ngModel)]="selectedOptions[fileIndex][fieldEntry.fieldIndex]"
                                                    (ngModelChange)="onDropdownChanged($event, file, fieldEntry.field)"
                                                    placeholder="Discover.contactImporter.placeholders.input"
                                                    [ariaLabel]="fieldEntry.field.originalField.label"
                                                    [disabled]="row.selectedOptionIndex !== optionIndex"
                                                    [class.agpr-fieldlist-radioOption--disable-hover-effect]="row.selectedOptionIndex !== optionIndex"
                                                ></agpr-dropdown>
                                                <span
                                                    *ngIf="fieldEntry.field.exampleValue"
                                                    class="agpr-fieldlist-fieldExamples"
                                                >
                                                    {{fieldEntry.field.exampleValue}}
                                                </span>
                                                <span
                                                    *ngIf="!fieldEntry.field.exampleValue && selectedOptions[fileIndex][fieldEntry.fieldIndex]?.value?.columnIndex == null"
                                                    class="agpr-fieldlist-fieldExamples-placeholder"
                                                >
                                                    {{ 'Discover.contactImporter.placeholders.preview' | localize }}
                                                </span>
                                                <span
                                                    *ngIf="!fieldEntry.field.exampleValue && selectedOptions[fileIndex][fieldEntry.fieldIndex]?.value?.columnIndex != null"
                                                    class="agpr-fieldlist-fieldExamples-placeholder"
                                                >
                                                    {{ 'Discover.contactImporter.placeholders.noData' | localize }}
                                                </span>
                                            </div>
                                        </ng-container>

                                    </ng-container>
                                </ng-container>

                            </ng-container>
                        </div>
                    </agpr-scroll-panel>
                </agpr-tab>
            </agpr-tabs>
        </div>
        <agpr-action-bar>
            <ng-template #left>
                <agpr-button
                    id="contactImport.cancelButton"
                    *ngIf="overlayMode"
                    label="cancel"
                    [style]="buttonTypes.secondary"
                    (click)="closeImporter()"
                ></agpr-button>
            </ng-template>
            <ng-template #right>
                <agpr-button
                    [id]="id + '_importButton'"
                    label="Discover.contactImporter.importButton"
                    [primary]="true"
                    [style]="buttonTypes.primary"
                    [disabled]="csvFiles.length === 0 || (selectedImportListAction === importListActions.list && listsForAllFilesChips.length === 0)"
                    [tooltip]="csvFiles.length === 0
                    ? 'Discover.contactImporter.tooltip.fileRequired'
                    : (selectedImportListAction === importListActions.list && listsForAllFilesChips.length === 0
                        ? 'Discover.contactImporter.tooltip.listRequired'
                        : '')
                    "
                    [ariaDescribedBy]="id + '_importButton_disabledButtonMessage'"
                    (click)="import()"
                ></agpr-button>
                <div
                    class="u-srOnly"
                    [id]="id + '_importButton_disabledButtonMessage'"
                >
                    <span *ngIf="csvFiles.length === 0">
                        {{'Discover.contactImporter.tooltip.fileRequired' | localize }}
                    </span>
                    <span *ngIf="selectedImportListAction === importListActions.list && listsForAllFilesChips.length === 0">
                        {{'Discover.contactImporter.tooltip.listRequired' | localize }}
                    </span>
                </div>

            </ng-template>
        </agpr-action-bar>
    </section>
    <aside
        class="agpr-sidebar"
        [attr.aria-label]="'Common.layout.rhp' | localize"
    >
        <agpr-right-sidebar>
            <ng-container *ngIf="csvFiles.length > 0">
                <agpr-file-upload
                    [id]="id + '_fileUpload'"
                    [maxFiles]="FILE_LIMIT"
                    [supportedFileTypesRegex]="csvMimeFileTypesRegex"
                    [supportedFileTypes]="csvMimeFileTypes"
                    header="Discover.contactImporter.rhp.uploadedFiles.header"
                    headerTooltip="Discover.contactImporter.rhp.uploadedFiles.info"
                    uploadButtonLabel="Discover.contactImporter.rhp.uploadedFiles.button"
                    [ngModel]="initialFileList"
                    (onAdd)="filesAdded($event)"
                    (onRemove)="fileRemoved($event)"
                    (onValidationError)="fileValidationErrors($event)"
                    [holdFileData]="true"
                    [validationFunction]="validateFileEncoding"
                ></agpr-file-upload>
                <agpr-panel
                    header="Discover.contactImporter.rhp.importOptions.header"
                    [toggleable]="false">
                    <div class="agpr-rhp-importOptions-container">
                        <agpr-checkbox
                            [id]="id + '_matchCheckbox'"
                            label="Discover.contactImporter.rhp.importOptions.matchCheckbox"
                            [binary]="true"
                            infoCircleTooltip="Discover.contactImporter.rhp.importOptions.matchCheckbox.tooltip"
                            [(ngModel)]="parameters.replaceWithSystemContacts"
                        ></agpr-checkbox>
                    </div>
                    <div
                        class="agpr-rhp-importOptions-container"
                        role="radiogroup"
                        [attr.aria-label]="'Discover.contactImporter.rhp.importOptions.header' | localize"
                    >
                        <agpr-radio
                            [id]="id + '_individualContacts_checkbox'"
                            [value]="importListActions.individual"
                            name="import_options"
                            label="Discover.contactImporter.rhp.importOptions.individual"
                            hiddenLabel="Discover.contactImporter.rhp.importOptions.individual"
                            [(ngModel)]="selectedImportListAction"
                            tooltip="Discover.contactImporter.rhp.importOptions.individual.tooltip"
                        ></agpr-radio>
                        <div class="agpr-rhp-importOptions-radioAndButtonContainer">
                            <agpr-radio
                                [id]="id + '_addAllToLists_checkbox'"
                                [value]="importListActions.list"
                                name="import_options"
                                label="Discover.contactImporter.rhp.importOptions.list"
                                hiddenLabel="Discover.contactImporter.rhp.importOptions.list"
                                [(ngModel)]="selectedImportListAction"
                                tooltip="Discover.contactImporter.rhp.importOptions.list.tooltip"
                            ></agpr-radio>
                            <agpr-button
                                *ngIf="selectedImportListAction === importListActions.list"
                                [id]="id + '_selectListForAllFileButton'"
                                label="Discover.contactImporter.rhp.importOptions.selectLists"
                                hiddenLabel="Discover.contactImporter.rhp.importOptions.selectLists"
                                [style]="buttonTypes.tertiary"
                                (click)="openListPicker()"
                            ></agpr-button>
                        </div>
                        <agpr-chip-container
                            *ngIf="selectedImportListAction === importListActions.list && listsForAllFilesChips.length > 0"
                            [chips]="listsForAllFilesChips"
                            class="agpr-rhp-importOptions-chips"
                            (removeChip)="unselectListChip($event)"
                        ></agpr-chip-container>

                        <agpr-radio
                            [id]="id + '_addIndividualToLists_checkbox'"
                            [value]="importListActions.listPerFile"
                            name="import_options"
                            label="Discover.contactImporter.rhp.importOptions.listPerFile"
                            hiddenLabel="Discover.contactImporter.rhp.importOptions.listPerFile"
                            [(ngModel)]="selectedImportListAction"
                            tooltip="Discover.contactImporter.rhp.importOptions.listPerFile.tooltip"
                        ></agpr-radio>
                        <ng-container *ngIf="selectedImportListAction === importListActions.listPerFile">
                            <div
                                *ngFor="let file of csvFiles; let fileIndex = index"
                                class="agpr-rhp-importOptions-filePerList-container"
                            >
                                <div class="agpr-rhp-importOptions-filePerList-headerContainer">
                                    <span class="agpr-rhp-importOptions-filePerList-label">{{file.fileName}}</span>
                                    <div class="agpr-rhp-importOptions-filePerList-headerContainer-radio">
                                        <agpr-radio
                                            [id]="id + '_' + fileIndex + '_createList_radioBtn'"
                                            [value]="true"
                                            [name]="'file_' + fileIndex + '_list_options'"
                                            label="Discover.contactImporter.rhp.importOptions.createNewListWithFilename"
                                            hiddenLabel="Discover.contactImporter.rhp.importOptions.createNewListWithFilename"
                                            [(ngModel)]="file.fileParameters.createNewListWithFilename"
                                            (ngModelChange)="onCreateList($event, file)"
                                        ></agpr-radio>
                                        <agpr-radio
                                            [id]="id + '_' + fileIndex + '_selectLists_radioBtn'"
                                            [value]="false"
                                            [name]="'file_' + fileIndex + '_list_options'"
                                            label="Discover.contactImporter.rhp.importOptions.selectLists"
                                            hiddenLabel="Discover.contactImporter.rhp.importOptions.selectLists"
                                            [(ngModel)]="file.fileParameters.createNewListWithFilename"
                                        ></agpr-radio>
                                    </div>
                                    <div class="agpr-rhp-importOptions-filePerList-headerContainerIndent">
                                        <agpr-autocomplete-chips
                                            *ngIf="!file.fileParameters.createNewListWithFilename"
                                            [id]="id + '_' + fileIndex + '_autoComplete'"
                                            placeholder="Discover.contactImporter.rhp.importOptions.selectLists.placeholder"
                                            [autocompleteOptions]="listAutocompleteOptions"
                                            field="name"
                                            [(ngModel)]="listsPerFileChips[file.fileName]"
                                            (ngModelChange)="onSelectListChange($event, file)"
                                            (buttonPress)="openListPickerForFile(file)"
                                            [button]="listPickerButton"
                                            [ariaInvalid]="file.fileParameters.noListsError"
                                            [ariaDescribedBy]="'selectList_errors_' + fileIndex"
                                        ></agpr-autocomplete-chips>
                                        <ul
                                            [id]="'selectList_errors_' + fileIndex"
                                        >
                                            <li>
                                                <agpr-form-message
                                                    *ngIf="file.fileParameters.noListsError"
                                                    [severity]="messageSeverity.error"
                                                >
                                                    {{ 'Discover.contactImporter.rhp.importOptions.selectLists.error' | localize }}
                                                </agpr-form-message>
                                            </li>
                                        </ul>


                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="agpr-rhp-importOptions-container">
                        <agpr-email-chips
                            [id]="id + '_reportRecipients_chips'"
                            [(value)]="parameters.reportDestinationEmails"
                            placeholder="Discover.contactImporter.rhp.importOptions.reportEmails.placeholder"
                            errorKey="Discover.targeting.distribution.editRecipient.invalidEmailMessage"
                            showDuplicateErrorKey="Common.forms.email.duplicateEmail"
                            [header]="'Discover.contactImporter.rhp.importOptions.reportEmails.label'"
                            tooltip="Discover.contactImporter.rhp.importOptions.reportEmails.info"
                    ></agpr-email-chips>
                    </div>
                </agpr-panel>
            </ng-container>
        </agpr-right-sidebar>
    </aside>
</main>

<input #fileInput
    style="display:none;"
    type="file"
    accept=".csv"
    multiple="multiple"
    (change)="filesSelected($event)"
/>
